import { FuseNavigation } from '@fuse/types';

export const navigation: FuseNavigation[] = [
    {
        id: 'Autenticacion',
        title: 'Autenticación',
        type: 'group',
        icon: 'lock',
        children: [
            {
                id: 'login',
                title: 'Iniciar Sesión',
                type: 'item',
                icon: 'lock',
                url: '/login'
            },
        ]
	},
    {
        id: 'Contratacion',
        title: 'Contratación',
        type: 'group',
        icon: 'app',
        children: [
            {
                id: 'DatosBasicos',
                title: 'Datos básicos',
                type: 'collapsable',
                icon: 'apps',
                children: [
                    {
                        id: 'Vigencia',
                        title: 'Vigencia',
                        type: 'item',
                        icon: 'calendar_today',
                        roles: "ContratacionApi_DatosBasicos",
                        url: '/datos-basicos/vigencia'
                    },
                    {
                        id: 'Tercero',
                        title: 'Tercero',
                        type: 'item',
                        icon: 'directions_walk',
                        roles: 'ContratacionApi_GestionTercero',
                        url: '/datos-basicos/tercero'
                    },
                    {
                        id: 'TerceroDependencia',
                        title: 'Dependencias',
                        type: 'item',
                        icon: 'widgets',
                        roles: 'ContratacionApi_DatosBasicos',
                        url: '/datos-basicos/dependencia/tercero'
                    },
                    {
                        id: 'ModalidadSeleccion',
                        title: 'Modalidad de Selección',
                        type: 'item',
                        icon: 'scatter_plot',
                        roles: 'ContratacionApi_DatosBasicos',
                        url: '/datos-basicos/modalidad-seleccion/consulta'
                    },
                    {
                        id: 'TiposContratos',
                        title: 'Tipos Contratos',
                        type: 'item',
                        icon: 'group_work',
                        roles: 'ContratacionApi_DatosBasicos',
                        url: '/datos-basicos/gestion/tipo-contrato'
                    },
                    {
                        id: 'CausalesContratacion',
                        title: 'Justificación de Modalidad',
                        type: 'item',
                        icon: 'category',
                        roles: 'ContratacionApi_DatosBasicos',
                        url: '/datos-basicos/gestion/causales-contratacion'
                    },
                    {
                        id: 'TiposDePlantilla',
                        title: 'Tipos Plantillas',
                        type: 'item',
                        icon: 'filter_list',
                        roles: 'ContratacionApi_DatosBasicos',
                        url: '/datos-basicos/gestion/tipo-plantilla',
                    },
                    {
                        id: 'GestionPlantillas',
                        title: 'Plantillas Word',
                        type: 'item',
                        icon: 'insert_drive_file',
                        roles: 'ContratacionApi_DatosBasicos',
                        url: '/datos-basicos/gestion/plantilla',
                    },
                    {
                        id: 'GestionParametros',
                        title: 'Parámetros',
                        type: 'item',
                        icon: 'build',
                        roles: 'ContratacionApi_DatosBasicos',
                        url: '/datos-basicos/gestion/parametro',
                    },
                    {
                        id: 'CalculadoraPlazos',
                        title: 'Calculadora de Plazos',
                        type: 'item',
                        icon: 'device_hub',
                        roles: 'ContratacionApi_DatosBasicos, ContratacionApi_CalculadoraPlazoValor',
                        url: '/datos-basicos/calculadora-plazos',
                    },
                    {
                        id: 'Bancos',
                        title: 'Bancos',
                        type: 'item',
                        icon: 'account_balance',
                        roles: 'ContratacionApi_DatosBasicos',
                        url: '/datos-basicos/bancos',
                    },
                ]
            },
            {
                id: 'solicitudContrato',
                title: 'Solicitudes de Contrato',
                type: 'collapsable',
                icon: 'work',
                children: [
                    {
                        id: 'SolicitarContrato',
                        title: 'Gestionar Solicitudes',
                        type: 'item',
                        icon: 'find_in_page',
                        roles: "ContratacionApi_SolicitudContrato, ContratacionApi_RealizarTrasladoDeVigenciaEstudioPrevio",
                        url: '/solicitud-contrato/solicitudes'
                    },
                    {
                        id: 'FirmarDocumentosDeEstudioPrevio',
                        title: 'Firmar Documentos',
                        type: 'item',
                        icon: 'note',
                        roles: "ContratacionApi_SolicitudContrato, ContratacionApi_JefeDependencia",
                        url: '/solicitud-contrato/documentos'
                    },
                    {
                        id: 'EditarSoportesEstudioPrevio',
                        title: 'Editar Soportes De Solicitud Contrato',
                        type: 'item',
                        icon: 'folder_special',
                        roles: "ContratacionApi_EditarSoportesDeSolicitudContrato",
                        url: '/solicitud-contrato/editar-soportes'
                    }
                ]
            },
            {
                id: 'unidadContratacion',
                title: 'Unidad Contratación',
                type: 'collapsable',
                icon: 'gavel',
                children: [
                    {
                        id: 'dashboardRevisor',
                        title: 'Dashboard Revisor',
                        type: 'item',
                        icon: 'dashboard',
                        roles: "ContratacionApi_RevisorDocumentos",
                        url: '/contratos/unidad-contratacion/revisor-documentos/dashboard'
                    },
                    {
                        id: 'dashboardJefeUnidadContratacion',
                        title: 'Dashboard',
                        type: 'item',
                        icon: 'dashboard',
                        roles: "ContratacionApi_JefeDependencia",
                        url: '/contratos/jefe-dependencia/dashboard-jefe'
                    },
                    {
                        id: 'solicitudesContrato',
                        title: 'Solicitudes',
                        type: 'item',
                        icon: 'flight_takeoff',
                        roles: "ContratacionApi_UnidadContratacionGestionSolicitudes",
                        url: '/solicitud-contrato/unidad-contratacion/solicitudes'
                    },
                    {
                        id: 'autorizacionSolicitudesContrato',
                        title: 'Autorizar Solicitudes',
                        type: 'item',
                        icon: 'explore',
                        roles: "ContratacionApi_AutorizarEstudiosPrevios",
                        url: '/solicitud-contrato/unidad-contratacion/autorizar-solicitudes'
                    },
                    {
                        id: 'misSolicitudes',
                        title: 'Mis Solicitudes',
                        type: 'item',
                        icon: 'library_books',
                        roles: "ContratacionApi_UnidadContratacionEstructuradorDeContratos",
                        url: '/solicitud-contrato/unidad-contratacion/mis-solicitudes'
                    },
                    {
                        id: 'misProcesos',
                        title: 'Mis Procesos',
                        type: 'item',
                        icon: 'settings_applications',
                        roles: "ContratacionApi_UnidadContratacionEstructuradorDeContratos",
                        url: '/solicitud-contrato/unidad-contratacion/mis-procesos'
                    },
                    {
                        id: 'ProcesosContratacion',
                        title: 'Procesos de Contratación',
                        type: 'item',
                        icon: 'settings_brightness',
                        roles: "ContratacionApi_CrearContratos",
                        url: '/solicitud-contrato/unidad-contratacion/procesos-contratacion'
                    },
                    {
                        id: 'contratosEnUnidadContratacion',
                        title: 'Contratos',
                        type: 'item',
                        icon: 'dns',
                        roles: "ContratacionApi_UnidadContratacionGestionContratos, ContratacionApi_AuxiliarAdministrativo, ContratacionApi_LegalizadorContratos",
                        url: '/contratos/unidad-contratacion/gestion'
                    },
                    {
                        id: 'informacionFinancieraContratos',
                        title: 'Información Financiera',
                        type: 'item',
                        icon: 'account_balance',
                        roles: "ContratacionApi_InformacionFinancieraContratos",
                        url: '/contratos/unidad-contratacion/informacion-financiera'
                    },
                    {
                        id: 'contratosPorTipoConsecutivo',
                        title: 'Contratos por consecutivo',
                        type: 'item',
                        icon: 'dns',
                        roles: "ContratacionApi_AuxiliarAdministrativo",
                        url: '/contratos/por-tipo-consecutivo/gestion'
                    },
                    {
                        id: 'consultarContratos',
                        title: 'Consultar Contratos',
                        type: 'item',
                        icon: 'description',
                        roles: "ContratacionApi_AuxiliarAdministrativo,ContratacionApi_FirmasUnidadContratacion",
                        url: '/contratos/consultar'
                    },
                    {
                        id: 'editarContratos',
                        title: 'Editar Contratos',
                        type: 'item',
                        icon: 'edit',
                        roles: "ContratacionApi_EditarContrato",
                        url: '/contratos/editar'
                    },
                    {
                        id: 'legalizarContratos',
                        title: 'Legalización de Contratos',
                        type: 'item',
                        icon: 'gavel',
                        roles: "ContratacionApi_LegalizadorContratos,ContratacionApi_AuxiliarAdministrativo",
                        url: '/contratos/legalizacion'
                    },
                    {
                        id: 'modificatoriosContratos',
                        title: 'Modificatorios Contrato',
                        type: 'item',
                        icon: 'swap_horiz',
                        roles: "ContratacionApi_RealizarModificatorios",
                        url: '/contratos/modificatorios'
                    },
                    {
                        id: 'gestionModificatoriosSolicitados',
                        title: 'Solicitudes Modificación',
                        type: 'item',
                        icon: 'settings',
                        roles: "ContratacionApi_UnidadContratacionEstructuradorDeContratos",
                        url: '/contratos/gestion-modificatorios'
                    },
                    {
                        id: 'certificacionesContratos',
                        title: 'Certificaciones Contrato',
                        type: 'item',
                        icon: 'contacts',
                        roles: "ContratacionApi_CertificacionesContrato",
                        url: '/contratos/certificaciones'
                    },
                    {
                        id: 'firmarDocumentosPendientesEnUnidadContratacion_Jefe',
                        title: 'Firmar Documentos',
                        type: 'item',
                        icon: 'rate_review',
                        roles: "ContratacionApi_JefeDependencia",
                        url: '/contratos/unidad-contratacion/jefe/contratos'
                    }, 
                ]
            },
            
            {
                id: 'Dashboard',
                title: 'Tablero de Control',
                type: 'collapsable',
                icon: 'dashboard',
                children: [                    
                    {
                        id: 'DashboardContratacion',
                        title: 'Contratación',
                        type: 'item',
                        icon: 'dashboard',
                        roles: 'ContratacionApi_DashboardDeContratacion',
                        url: '/dashboard/contratacion/'
                    }
                ]
            },
        ]
    },
    {
        id: 'Contratista',
        title: 'Contratista',
        type: 'group',
        icon: 'lock',
        children: [
            {
                id: 'misContratos',
                title: 'Contratos',
                type: 'item',
                icon: 'description',
                roles: 'ContratacionApi_Contratista',
                url: '/contratista/mis-contratos'
            }
        ]
    },
    {
        id: 'RecursosHumanos',
        title: 'Recursos Humanos',
        type: 'group',
        icon: 'lock',
        children: [
            {
                id: 'gestionSolicitudes',
                title: 'Gestión Solicitudes Personal',
                type: 'item',
                icon: 'inbox',
                roles: 'ContratacionApi_RecursosHumanosSolicitudes',
                url: '/recursos-humanos/solicitudes-personal'
            },
            {
                id: 'RecursosHumanos_gestionDocumentos',
                title: 'Firmar Documentos',
                type: 'item',
                icon: 'note',
                roles: "ContratacionApi_RecursosHumanosSolicitudes, ContratacionApi_RecursosHumanos_AprobarDocumentos",
                url: '/recursos-humanos/documentos'
            }
        ]
    },
    {
        id: 'Supervision',
        title: 'Supervisión',
        type: 'group',
        icon: 'lock',
        children: [
            {
                id: 'misContratos',
                title: 'Contratos',
                type: 'item',
                icon: 'supervised_user_circle',
                roles: 'ContratacionApi_Supervisor',
                url: '/supervision/mis-contratos'
            },
            {
                id: 'solicitudesModificatorios',
                title: 'Solicitudes de Modificación',
                type: 'item',
                icon: 'settings_applications',
                roles: 'ContratacionApi_Supervisor',
                url: '/supervision/solicitudes-modificacion'
            },
            {
                id: 'gestionInformeActividades',
                title: 'Informe de Actividades',
                type: 'item',
                icon: 'library_books',
                roles: 'ContratacionApi_Supervisor',
                url: '/supervision/informes-actividades'
            },
            {
                id: 'misInformesSupervision',
                title: 'Informe de Supervisión',
                type: 'item',
                icon: 'video_library',
                roles: 'ContratacionApi_Supervisor',
                url: '/supervision/informes-supervision'
            },
            {
                id: 'contratosPorJefeDependencia',
                title: 'Designación de supervisión',
                type: 'item',
                icon: 'dns',
                roles: "ContratacionApi_GestionContratosPorJefeDependencia",
                url: '/contratos/jefe-dependencia/gestion'
            },
        ]
    },
    {
        id: 'Interventoria',
        title: 'Interventoría',
        type: 'group',
        icon: 'lock',
        children: [
            {
                id: 'misContratos',
                title: 'Contratos',
                type: 'item',
                icon: 'supervised_user_circle',
                roles: 'ContratacionApi_Interventor',
                url: '/interventoria/mis-contratos'
            },
        ]
    },
    {
        id: 'Consultas',
        title: 'Consultas',
        type: 'group',
        icon: 'lock',
        children: [
            {
                id: 'consultarProcesosPorNumeroProceso',
                title: 'Consultar Proceso Contratación',
                type: 'item',
                icon: 'compare',
                roles: "ContratacionApi_EstudioPrevioConsultaPorNumeroProceso",
                url: 'solicitud-contrato/buscar/numero-proceso'
            },
            {
                id: 'consultarContratos',
                title: 'Consultar Contrato',
                type: 'item',
                icon: 'description',
                roles: "ContratacionApi_ConsultaContratoPorNumero",
                url: '/contratos/consultar'
            },
            {
                id: 'contratosPorDependencia',
                title: 'Contratos por Dependencia',
                type: 'item',
                icon: 'store',
                roles: "ContratacionApi_ConsultaContratosPorDependencia",
                url: '/contratos/dependencia'
            },
        ]
    },
    {
        id: 'Contabilidad',
        title: 'Hacienda',
        type: 'group',
        icon: 'lock',
        children: [
            {
                id: 'registroRp',
                title: 'Registrar Rps (SGR)',
                type: 'item',
                icon: 'movie',
                roles: 'ContratacionApi_ContabilidadRegistrarRp',
                url: '/contabilidad/registrar-rp'
            },
            {
                id: 'informesSupervision',
                title: 'Informes Supervisión',
                type: 'item',
                icon: 'supervisor_account',
                roles: 'ContratacionApi_ContabilidadInformesSupervisionAprobados',
                url: '/contabilidad/informes-supervision'
            },
            {
                id: 'informesSupervisionDevueltos',
                title: 'Informes Supervisión Devueltos',
                type: 'item',
                icon: 'record_voice_over',
                roles: 'ContratacionApi_ContabilidadDevolverInformesSupervisionAceptados',
                url: '/contabilidad/informes-supervision-devueltos'
            },
            {
                id: 'historicoInformesSupervision',
                title: 'Histórico Informes Supervisión',
                type: 'item',
                icon: 'history',
                roles: 'ContratacionApi_ContabilidadHistoricoInformeSupervision',
                url: '/contabilidad/informe-supervision/historico'
            },
            {
                id: 'consultaOrdenesPago',
                title: 'Órdenes de Pago',
                type: 'item',
                icon: 'account_balance_wallet',
                url: '/contabilidad/ordenes-pagos'
            },
        ]
    },
    {
        id: 'Reportes',
        title: 'Reportes',
        type: 'group',
        icon: 'lock',
        children: [
            {
                id: 'reporteParametrizadoContratos',
                title: 'Contratos Parametrizado',
                type: 'item',
                icon: 'book',
                roles: 'ContratacionApi_ReporteParametrizadoDeContratos',
                url: '/reportes/contratos-parametrizado'
            },
            {
                id: 'reporteBasicoContrato',
                title: 'Contratos',
                type: 'item',
                icon: 'assessment',
                roles: 'ContratacionApi_ReporteBasicoDeContratos',
                url: '/reportes/contratos'
            },
            {
                id: 'reporteContratistas',
                title: 'Contratistas',
                type: 'item',
                icon: 'contact_mail',
                roles: 'ContratacionApi_ReporteContratistas',
                url: '/reportes/contratistas'
            },
            {
                id: 'reporteMensualContratos',
                title: 'Contrato Por Mes',
                type: 'item',
                icon: 'receipt',
                roles: 'ContratacionApi_ReporteMensualDeContratos',
                url: '/reportes/contratos-mensual'
            },
        ]
    },
    {
        id: 'Presupuesto',
        title: 'Presupuesto',
        type: 'group',
        icon: 'lock',
        children: [
            {
                id: 'liquidacionesConSaldoAFavorEntidad',
                title: 'Liquidaciones con Saldo a Favor',
                type: 'item',
                icon: 'data_usage',
                roles: 'ContratacionApi_PresupuestoLiquidacionesConSaldoAFavor',
                url: '/presupuesto/liquidaciones-saldo-a-favor'
            },
        ]
    },
];